import { isFessh } from "./is-fessh";

export const pageTitle = (title: string) => {
  return `${title} - ${isFessh ? "Fessh" : "CongressWorks"}`;
};
